import React from 'react';
import { DialogContentText } from '@mui/material';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { importProjectDataFileWithoutConfirmation } from '../../store/actions/layout/layoutActions';
import { ConfirmReplaceLayoutDialogProps } from '../../store/actions/popupActions';
import { useAppDispatch } from '../hooks';

export function ReplaceLayoutConfirmDialog({ file, layoutOnly }: ConfirmReplaceLayoutDialogProps) {
  const dispatch = useAppDispatch();

  return (
    <Dialog
      insistent
      variant="design"
      title="Replace Existing Layout?"
      submitText="Replace Layout"
      cancelText="Cancel"
      onSubmit={async () => {
        dispatch(closeCurrentPopup());
        await dispatch(importProjectDataFileWithoutConfirmation(file, layoutOnly));
      }}
      onCancel={() => {
        dispatch(closeCurrentPopup());
      }}
    >
      <DialogContentText>
        This project already contains layout elements. Importing the selected file will replace the entire layout and
        cannot be undone.
      </DialogContentText>
    </Dialog>
  );
}
